(() => {
    const createCheckoutSession = function (stripePriceId) {
        return fetch('/stripe/create-checkout-session', {
            method: 'POST',
            headers: {
                'X-Csrf-Token': document.head.querySelector('meta[name="csrf-token"]').content,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                stripe_price_id: stripePriceId,
            }),
        }).then(function (result) {
            return result.json();
        });
    };

    const buttons = document.querySelectorAll('button[role*="subscribe-button"]');
    for (const button of buttons) {
        button.addEventListener('click', function () {
            const stripe = window.Stripe(process.env.MIX_STRIPE_PUBLISHABLE_KEY);

            createCheckoutSession(button.getAttribute('data-stripe-price-id')).then(function (data) {
                stripe
                    .redirectToCheckout({
                        sessionId: data.sessionId,
                    })
                    .then(handleResult);
            });
        });
    }
})();
